import * as z from "zod";

export const updateSelfServeOnboardingContacted = {
  name: "updateSelfServeOnboardingContacted" as const,
  input: z.object({
    merchantId: z.string(),
    contacted: z.boolean(),
    contactedBy: z.string().optional(),
    product: z.enum(["returns", "order-editing"]).default("returns"),
  }),
  output: z.object({ success: z.boolean() }),
};
